export function AvailabilitySvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/availability.svg'"></ng-include>`
    }
}